import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Zap, RotateCcw, Mail } from "lucide-react";
import logo from "@/assets/Weautomate logo-01.png";

export default function ServerError() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] rounded-full bg-gradient-to-r from-[#FF3366] to-[#FF9900] opacity-[0.06] blur-3xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10"
      >
        <img src={logo} alt="WeAutomate" className="h-10 w-auto mx-auto mb-10" />

        <motion.div
          animate={{ scale: [1, 1.12, 1], rotate: [0, -8, 8, 0] }}
          transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
          className="mx-auto mb-8 w-20 h-20 rounded-2xl gradient-bg flex items-center justify-center"
        >
          <Zap className="w-10 h-10 text-white" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15 }}
          className="font-display text-[120px] lg:text-[160px] leading-none gradient-text select-none"
        >
          500
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-3xl lg:text-5xl tracking-tighter mt-2"
        >
          Something sparked on our end.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="mt-4 text-white/50 max-w-sm mx-auto"
        >
          Our team has been notified. A quick retry usually does the trick.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-10 flex flex-wrap justify-center gap-3"
        >
          <button onClick={() => nav(0)}
                  className="flex items-center gap-2 px-5 py-2.5 rounded-full gradient-bg font-medium text-sm hover:shadow-[0_0_20px_rgba(157,76,221,0.4)] transition-shadow">
            <RotateCcw className="w-4 h-4" /> Try again
          </button>
          <Link to="/contact"
                className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/15 hover:border-white/30 text-white/70 hover:text-white transition-colors text-sm">
            <Mail className="w-4 h-4" /> Contact us
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
}
